import React, {useEffect, useState} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/SolutionsPage.css";
import EmptyState from "../components/EmptyState";
import SEO from "../components/SEO";

import {toast} from "react-hot-toast";

import * as productService from "../_services/products.service";

export default function SolutionsPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [solutions, setSolutions] = useState([]);
  const [onError, setOnError] = useState(true);

  const params = new URLSearchParams(location.search);
  const proceedTo = params.get("proceedTo") || "register";
  const tenantId = params.get("tenantId") || null;

  const handleFetch = async () => {
    setLoading(true);
    try {
      const getProducts = await productService.get({status: "all"});
      setSolutions(getProducts.data);
      setOnError(false);
    } catch (error) {
      setSolutions([]);
    } finally {
      setLoading(false);
      setOnError(true);
    }
  }

  useEffect(() => {
    handleFetch();
  }, []);

  const handleNavigate = (product) => {
    navigate(`./${product.slug}?productId=${product.productId}&proceedTo=${proceedTo}&tenantId=${tenantId}`, {state:{product}});
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <SEO
        title="Magyne Solutions | Business Management Software"
        description="Explore Magyne's industry-specific SaaS and ERP solutions for schools, healthcare, local government, car washes, hotels and businesses."
        path="/solutions"
      />

      <main> 
        <div className="solutions-page">
          {/* Animated Background Blobs */}
          <div className="bg-blobs">
            <div className="blob blob1"></div>
            <div className="blob blob2"></div>
            <div className="blob blob3"></div>
          </div>

          <section className="solutions-hero">
            <h1>Magyne Business Management Solutions</h1>
            <p>
              Magyne provides specialized software solutions that help
              organizations manage their daily operations efficiently.
            </p>
            <hr/>
          </section>

          {
            !loading && solutions.length
            ? <section className="solutions-grid">
                {solutions.map((product, idx) => (
                  <div
                    key={idx}
                    className="solution-card"
                    onClick={() => handleNavigate(product)}
                    style={{ backgroundImage: `url(${product.img})` }}
                  >
                    <div
                      className="solution-overlay"
                      style={{ backgroundColor: product.color + "88" }}
                    >
                      <h3>{product.productName}</h3>
                      <p>{product.description}</p>
                    </div>
                  </div>
                ))}
              </section>
            : !loading && !solutions.length
            ? <EmptyState
                title = "No Products Available"
                message = "There are no products available at the moment."
                buttonText = ""
              />
            : loading
            ? <div>
                <div className="spinner"></div>
                <p className="text-center">
                  Loading products. <br/>
                  Please wait...
                </p>
              </div>
            : onError
            ? <EmptyState
                title = "Ooops"
                message = "We seem to be having a minor issue with server. Please try to refresh... that might work"
                buttonText = "Refresh"
                buttonIcon="bi-arrow-clockwise"
                onButtonClick={handleFetch}
              />
            : <></>
          }
        </div>
      </main>
    </>
  );
}
